import React from "react";
import PropTypes from "prop-types";
import { Slide, Slider } from "@default/general-components/slider/slider";
import { SliderDots } from "@default/general-components/slider/slider-dots";
import VisualHeaderSlide from "./components/visual-header-slide";
import UniversalSliderButton from "@default/general-components/universal-slider-button";
import SliderProvider, {
  useSliderContext,
} from "@default/general-components/slider/context";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";

const VisualHeaderSlider = ({ slides }) => {
  const { simpleDesign } = useAccessibilityContext();
  const { emblaApi, canScrollPrev, canScrollNext } = useSliderContext();

  return (
    <>
      {simpleDesign && (
        <UniversalSliderButton
          type="prev"
          onClick={() => emblaApi?.scrollPrev()}
          sliderClassNames={!canScrollPrev ? "slick-disabled" : ""}
        />
      )}

      <Slider>
        {slides.map((slide, index) => (
          <Slide key={index}>
            <VisualHeaderSlide content={slide} index={index} />
          </Slide>
        ))}
      </Slider>

      {simpleDesign && (
        <UniversalSliderButton
          type="next"
          onClick={() => emblaApi?.scrollNext()}
          sliderClassNames={!canScrollNext ? "slick-disabled" : ""}
        />
      )}

      {!simpleDesign && <SliderDots />}
    </>
  );
};

const ParagraphVisualHeader = ({ content }) => {
  const slides = content.fieldSlides?.length ? content.fieldSlides : [];

  if (slides.length === 1) {
    return (
      <section className="paragraph paragraph-visual-header">
        <VisualHeaderSlide content={slides[0]} single />
      </section>
    );
  }

  return (
    <section className="paragraph paragraph-visual-header">
      <SliderProvider
        options={{ fade: true, autoplay: true, duration: 60 }}
        slideTypes={slides.map(
          (s) => s.fieldMultimediaSingle?.entityBundle ?? "image"
        )}
      >
        <VisualHeaderSlider slides={slides} />
      </SliderProvider>
    </section>
  );
};

ParagraphVisualHeader.propTypes = {};

export default ParagraphVisualHeader;
